import type { ComponentPropsWithoutRef } from "react";
import { Button } from "@/components/atoms/button";
import { cn } from "@/lib/utils";

export const ToolbarButton = ({
  type = "button",
  variant = "consoleSurface",
  size = "sm",
  className,
  ...rest
}: ComponentPropsWithoutRef<typeof Button>) => {
  return (
    <Button
      type={type}
      variant={variant}
      size={size}
      className={cn("group", className)}
      {...rest}
    />
  );
};
